@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label
      [attribute]="attribute"
      [passportId]="passportId"
    ></app-field-label>
    <div class="d-flex align-items-start gap-2 mt-1">
      @if (isBase64DataUri(control.value)) {
        <img
          [src]="control.value"
          [alt]="'battery_pass.image_picker.image_alt' | translate: {index: 1}"
          class="image-input-thumbnail"
        />
      } @else {
        <ix-input
            #documentInput
            (input)="control.value"
            (change)="control.value"
            [formControl]="control"
            [invalidText]="createInvalidText(control)"
            [ngClass]="{'ix-invalid': control.errors}"
            class="w-100 pe-2"
            id="{{attribute.name}}">
          <ix-icon name="globe" size="16" slot="start"></ix-icon>
        </ix-input>
      }
      <ix-icon-button
        icon="image"
        variant="subtle-primary"
        [ngClass]="{'ix-invalid': control.errors}"
        (click)="openPicker()"
        onkeypress=""
      >
      </ix-icon-button>
      <ix-icon-button
        icon="trashcan"
        variant="subtle-primary"
        (click)="deleteImage()"
        onkeypress=""
      >
      </ix-icon-button>
      @if (validatedImageUrl) {
        <a [href]="validatedImageUrl"
          rel="noopener noreferrer"
          target="_blank">
          <div
            [ngStyle]="{ 'background-image': 'url(' + validatedImageUrl + ')' }"
          class="document-image"></div>
        </a>
      } @else {
        <a
          [attr.href]="control.value ? control.value : null"
          rel="noopener noreferrer"
          target="_blank">
          <ix-icon-button [disabled]="control.value ===''"
          icon="open-external" variant="subtle-primary"></ix-icon-button>
        </a>
      }
    </div>
  </div>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
